import { render } from "./CashdeskDatatableTDSales.vue?vue&type=template&id=9d3bc178"
import script from "./CashdeskDatatableTDSales.vue?vue&type=script&lang=js"
export * from "./CashdeskDatatableTDSales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__